import {
  IotizeConfigFactory,
  IotizeConfigModel,
} from '@iotize/tap/config/iotize-studio';

import { XMLParser } from './xml-parser';

declare module '@iotize/tap/config/iotize-studio/lib/iotize-config-factory' {
  export interface IotizeConfigFactory {}
}

/**
 * Create IotizeConfigModel from a XML string
 * @param xml
 */
IotizeConfigFactory.fromXML = function (xml: string): IotizeConfigModel {
  return new IotizeConfigModel(new XMLParser().parseSync(xml));
};
